import { render, staticRenderFns } from "./RegularTables.vue?vue&type=template&id=4f22dd1c&scoped=true&"
import script from "./RegularTables.vue?vue&type=script&lang=js&"
export * from "./RegularTables.vue?vue&type=script&lang=js&"
import style0 from "./RegularTables.vue?vue&type=style&index=0&id=4f22dd1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f22dd1c",
  null
  
)

export default component.exports